import styled from '@emotion/styled';
import { Group } from '@mantine/core';

export const HomeHeaderCompletedContainer = styled(Group)`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
`;
